import { useAuth0 } from "@auth0/auth0-react";
import {
  getStoredGuestSession,
  markGuestSession,
  clearStoredGuestSession,
} from "../../services/guestStorage";

// Re-exported so existing importers (the components/Guest index) are unchanged.
// Guest storage now lives in the backend-scoped storage layer; clearGuestSession
// is the public alias for clearStoredGuestSession.
export { markGuestSession };
export const clearGuestSession = clearStoredGuestSession;

// "Is there a live guest session for the current backend?" — a stored token
// whose recorded business expiry hasn't passed. Storage is namespaced per API
// backend, so a token minted against a different backend reads as no session.
const readGuestFlag = (): boolean => Boolean(getStoredGuestSession());

export const useIsGuest = (): boolean => {
  const { isAuthenticated } = useAuth0();
  if (isAuthenticated) return false;
  return readGuestFlag();
};
